<template>
  <div class="qyjbxxBody">
    <div class="_title">
      <p class="_title_info">单位认证信息</p>
    </div>
    <div style="margin-top: 13px; position: relative">
      <el-image
        v-loading="yyzzImg.loading"
        :src="yyzzImg.img"
        :preview-src-list="qyxxImgList"
        draggable="false"
        style="width: 204px; height: 140px"
        alt=""
      />
    </div>
    <p
      style="
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #636363;
        line-height: 20px;
        margin-top: 10px;
      "
    >
      查看{{ dwxzWorld }}
    </p>
    <div v-if="isShowTestMenu && !dwhcpd" class="certificate_status">
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col :span="8">
          营业执照： <span>正常</span>
        </el-col>
        <el-col :span="8">
          安全许可证：<span>正常</span>
        </el-col>
        <el-col :span="8">
          法人和主要负责人违法情况：<span>正常</span>
        </el-col>
      </el-row>
    </div>
    <div class="_jbxxInfo">
      <div class="_jbxxTitle" @click="saveDoc()">单位基本信息：</div>
      <div class="_jbxxBd">
        <el-form
          disabled
          :model="jbxxForm"
          label-position="right"
          class="_jbxxForm"
          label-width="118px"
        >
          <el-form-item v-if="labelFlag.dwmc" :label="dwmcName">
            <el-input v-model="jbxxForm.dwmc" />
          </el-form-item>
          <el-form-item label="单位性质:">
            <el-select v-model="jbxxForm.dwxz" style="width: 100%">
              <el-option
                v-for="(item, i) in dwxzList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.shtyxydm && shtyxydmName != '统一社会信用代码:'"
            :label="shtyxydmName"
          >
            <el-input v-model="jbxxForm.shtyxydm" />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.shtyxydm && shtyxydmName == '统一社会信用代码:'"
            :label="shtyxydmName"
            label-width="160px"
          >
            <el-input v-model="jbxxForm.shtyxydm" />
          </el-form-item>
          <el-form-item v-if="labelFlag.dwlx" :label="dwlxName">
            <el-select
              v-model="jbxxForm.dwlx"
              style="width: 100%"
              placeholder="请选择单位类型"
            >
              <el-option
                v-for="(item, i) in dwlxList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="labelFlag.YyqxDate" :label="YyqxDateName">
            <el-date-picker
              v-model="YyqxDate"
              unlink-panels
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            /> </el-form-item><el-form-item v-if="labelFlag.clrq" :label="clrqName">
            <el-input v-model="jbxxForm.clrq" /> </el-form-item><el-form-item v-if="labelFlag.zczb" :label="zczbName">
            <el-input v-model="jbxxForm.zczb" />
            <el-select v-model="jbxxForm.zczbDw" placeholder="请选择货币">
              <el-option
                v-for="(item, i) in djdwList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="labelFlag.frmc" :label="frmcName">
            <el-input v-model="jbxxForm.frmc" />
          </el-form-item>
        </el-form>
      </div>
      <div class="_jbxxTitle">单位其他信息：</div>
      <div class="_qtxxBd">
        <el-form
          disabled
          label-position="right"
          class="_qtxxForm"
          label-width="118px"
          :model="jbxxForm"
        >
          <el-form-item v-if="labelFlag.dwzj" :label="dwzjName">
            <el-input
              v-model="jbxxForm.dwzj"
              placeholder="请输入单位座机 例:010-86551122"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.cyrysl" :label="cyryslName">
            <el-input
              v-model="jbxxForm.cyrysl"
              placeholder="请输入从业人员数量"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.zhxs" label="组合形式">
            <el-input
              v-model="jbxxForm.zhxs"
              placeholder="请输入组合形式"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.gsgajg" :label="gsgajgName" class="jydItem">
            <el-input
              v-model="jbxxForm.provinceLabel+' / '+jbxxForm.cityLabel+' / '+jbxxForm.countyLabel"
              placeholder="请输入行政区划"
            />
            <!--<el-cascader
              key="bbigdd"
              v-model="gsgajg"
              placeholder="请选择行政区划"
              :props="props"
            />-->
          </el-form-item>
          <el-form-item
            v-if="labelFlag.sjjyd"
            class="jydItem"
            :label="sjjydName"
          >
            <el-input
              v-model="jbxxForm.sjjyd"
              placeholder="请输入实际经营地"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.dwzs" :label="dwzsName" class="jydItem">
            <el-input
              v-model="jbxxForm.dwzs"
              placeholder="请输入单位住所"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.gsgajg" label="注册地区划:" class="jydItem">
            <el-input
              v-model="jbxxForm.sjProvinceLabel+' / '+jbxxForm.sjCityLabel+' / '+jbxxForm.sjCountyLabel"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.jyfw" :label="jyfwName">
            <el-input
              v-model="jbxxForm.jyfw"
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="请输入经营范围"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="dwhcpd" class="_title _title2">
      <p class="_title_info">法定代表人认证信息</p>
    </div>
    <div v-if="dwhcpd" class="sfzDiv">
      <div v-for="(item, index) in sfzImgList" :key="index" class="sfzDivItem">
        <el-image
          :preview-src-list="farenImgList"
          :src="item.path"
          draggable="false"
          alt=""
          style="width: 225px; height: 138px"
        />
        <p class="sfzP" style="text-align: center">{{ item.name }}</p>
      </div>
    </div>
    <div v-if="dwhcpd" class="_jbxxInfo">
      <div class="_jbxxTitle">身份证件信息：</div>
      <div class="_jbxxBd">
        <el-form
          disabled
          :model="frxxForm"
          label-position="right"
          class="_jbxxForm"
          label-width="118px"
        >
          <el-form-item label="姓名:">
            <el-input v-model="frxxForm.xm" />
          </el-form-item>
          <el-form-item label="性别:">
            <el-select
              v-model="frxxForm.xb"
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in sexList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码:">
            <el-input v-model="frxxForm.zjhm" />
          </el-form-item>
          <el-form-item label="民族:">
            <el-select
              v-model="frxxForm.mz"
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in mzList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select> </el-form-item><el-form-item label="出生日期:">
            <el-input v-model="frxxForm.sr" /> </el-form-item><el-form-item label="籍贯:">
            <!-- <el-cascader
              style="width: 100%"
              v-model="frxxForm.jg"
              clearable
              placeholder=""
              :props="jgprops"
              filterable
            ></el-cascader> -->
            <el-input v-model="frxxForm.jgLabel" /> </el-form-item><el-form-item label="有效期限:">
            <el-date-picker
              v-model="frYxqxDate"
              unlink-panels
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="发证机关:">
            <el-input v-model="frxxForm.fzjg" />
          </el-form-item>
        </el-form>
      </div>
      <div class="_jbxxTitle">其他信息：</div>
      <div class="_jbxxBd _qtxxBd">
        <el-form
          disabled
          :model="frxxForm"
          label-position="right"
          class="_jbxxForm"
          label-width="118px"
        >
          <el-form-item label="办公电话:">
            <el-input v-model="frxxForm.bgdh" />
          </el-form-item>
          <el-form-item label="手机号码:">
            <el-input v-model="frxxForm.sjhm" />
          </el-form-item>
          <el-form-item label="实际住址:" style="width: 100%" class="sjzzItem">
            <el-input v-model="frxxForm.sjzz" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="dwhcpd" class="_title _title2">
      <p class="_title_info">涉及化学物品</p>
    </div>
    <div v-if="dwhcpd" class="tableBody">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f4f4f4', color: '#6b6b6b' }"
      >
        <el-table-column prop="hxpmc" label="化学品名称" />
        <el-table-column prop="ywlxLabel" label="业务类型" />
        <el-table-column label="年涉及数量">
          <template slot-scope="scope">
            <span>{{
              scope.row.nsjsl + "(" + scope.row.nsjslDwLabel + ")"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="yt" label="用途" />
        <el-table-column v-if="isShowTestMenu" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="addMes(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next,jumper,total, sizes"
        :page-size="pagesize"
        :current-page="currentPage"
        :total="hxpTotal"
        :page-sizes="[10, 20]"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <div v-if="dwhcpd" class="_title _title2">
      <p class="_title_info">单位资质证件</p>
    </div>
    <ul v-if="dwhcpd" class="uploadzhengjian">
      <li v-for="(item, i) in imgListArray" :key="i" style="margin: 0px 30px">
        <img
          v-preventReClick
          :src="item.imageurl"
          alt=""
          @click="imageClick(item)"
        >
        <p v-html="item.name" />
      </li>
    </ul>
    <!-- 打开许可证弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogFormVisible1"
      center
      custom-class="zhengjiatable"
    >
      <el-table
        :data="imagetableData"
        border
        style="width: 100%"
        max-height="420"
      >
        <el-table-column
          v-for="(item, i) in headerlist"
          :key="i"
          align="center"
          :prop="item.prop"
          :label="item.label"
        >
          <template slot-scope="scope">
            <div v-if="item.label !== '操作'">
              {{ scope.row[item.prop] }}
            </div>
            <div v-if="item.label === '操作'">
              <el-button
                v-preventReClick
                type="primary"
                icon="el-icon-view"
                size="mini"
                style="background-color: #4170ff"
                @click="handleView(scope.$index, scope.row)"
              >查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 许可证弹窗的弹窗 -->
      <dialog-1
        ref="dialog1"
        :type="type"
        :dialog-form-visible="dialogFormVisible"
        :title="title"
        :zjlx="imagezjlx"
        @close-dialog="closeDialog"
      />
      <!-- 许可证弹窗的弹窗end -->
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="
            background-color: #4170ff;
            width: 90px;
            height: 40px;
            margin-bottom: 20px;
          "
          @click="dialogFormVisible1 = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <div v-if="dwhcpd" class="_title _title2">
      <p class="_title_info">审批核准信息</p>
    </div>
    <div v-if="dwhcpd" style="width: 100%">
      <el-timeline>
        <el-timeline-item v-if="rwSpjgDto[0]" icon="el-icon-time" size="large">
          <div style="margin-top: 2px">
            <span style="font-weight: bold"> 申请时间： </span>
            <span>{{ rwSpjgDto[0].clsj }}</span>
          </div>
        </el-timeline-item>
        <el-timeline-item
          v-for="(item, index) in rwSpjgDto"
          :key="index"
          :icon="index == rwSpjgDto.length - 1 ? 'el-icon-success' : ''"
          :type="item.type"
          :size="index == rwSpjgDto.length - 1 ? 'large' : item.size"
          :color="item.color"
        >
          <div style="display: flex">
            <div style="margin-right: 20px">
              <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
            </div>
            <div style="margin-right: 20px">
              <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
            </div>
            <div style="margin-right: 20px">
              <span style="font-weight: bold">审批结果：</span><span
                :style="
                  item.sftyLabel == '同意' ? 'color: #00ceb7' : 'color: red'
                "
              >{{ item.sftyLabel }}</span>
            </div>
            <div style="margin-right: 20px">
              <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
            </div>
          </div>
          <div style="margin-top: 2px">
            <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div v-if="dwhcpd && bgSpjgDtos && bgSpjgDtos.length > 0" class="_title _title2">
      <p class="_title_info">变更审批结果</p>
    </div>
    <div v-if="dwhcpd && bgSpjgDtos && bgSpjgDtos.length > 0" style="width: 100%">
      <div
        v-for="(item, index) in bgSpjgDtos"
        :key="index"
        style="margin-bottom: 30px"
      >
        <el-timeline>
          <el-timeline-item v-if="item[0]" icon="el-icon-time" size="large">
            <div style="margin-top: 2px">
              <span style="font-weight: bold"> 申请时间： </span>
              <span>{{ item[0].clsj }}</span>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-for="(arr, key) in item"
            :key="key"
            :icon="key == item.length - 1 ? 'el-icon-success' : ''"
            :type="arr.type"
            :size="key == item.length - 1 ? 'large' : arr.size"
            :color="arr.color"
          >
            <div style="display: flex">
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批单位：</span>{{ arr.dqbmLabel }}
              </div>
              <div v-if="arr.sftyLabel !== '待审批'" style="margin-right: 20px">
                <span style="font-weight: bold">{{ arr.jsLabel }}人：</span>{{ arr.sjsprLabel }}
              </div>
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批结果：</span><span
                  :style="
                    arr.sftyLabel == '同意'
                      ? 'color: #00ceb7'
                      : arr.sftyLabel == '不同意'
                        ? 'color: red'
                        : 'color: Orange'
                  "
                >{{ arr.sftyLabel }}</span><!--同意-> 00ceb7  不同意->red  待审批->Orange -->
              </div>
              <div v-if="arr.sftyLabel !== '待审批'" style="margin-right: 20px">
                <span style="font-weight: bold">审批时间：</span>{{ arr.spsj }}
              </div>
            </div>
            <div v-if="arr.sftyLabel !== '待审批'" style="margin-top: 2px">
              <span style="font-weight: bold">审批意见：</span><span>{{ arr.spyj }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div
      v-if="!dwhcpd && !qyarray.isWldw"
      style="text-align: center; padding-bottom: 50px"
    >
      <el-button
        v-preventReClick
        style="background-color: #4170ff; border: none"
        type="primary"
        @click="joinwldw"
      >加入往来单位</el-button>
    </div>
    <!-- 添加化学品弹窗 -->
    <div>
      <el-dialog
        v-if="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        destroy-on-close
        custom-class="waibu"
        center
      >
        <chemicalPupop
          ref="chemicalPupop"
          :content="content"
          :puptype="puptype"
          :source="'qyjbxx'"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dialog1 from '@/components/qyjbxx/qyjbxxDia.vue'
import chemicalPupop from '@/components/chemicalPupop'
import {isEmpty} from "@/utils/tool";
import {
  getXzqTree,
  getXzqTreeS
} from '@/assets/js/step2.js'
import { getkv, returnShowPic } from '@/assets/js/common.js'
import {
  getQyxx,
  getQyxxById,
  getHxpxx,
  getFjsjxxByZjlx,
  getFjsjxxByZjlxAndDwid,
  getFjxxByFjsjId,
  getFjxxByFjsjIdAndDwId, getHxpxxByDwid
} from '@/assets/js/dwjbxx.js'
// 获取接口地址
import { saveHxpxx } from '@/assets/js/common.js'
import { wldwAdd } from '@/assets/js/xxhc'
export default {
  components: {
    dialog1,
    chemicalPupop
  },
  props: {
    // 单位核查跳转
    dwhcpd: {
      type: Boolean
    },
    // 单位信息
    qyarray: {
      type: Object
    },
    //要展示的单位信息的主键
    nowDwId: {
      type: String
    }
  },

  data() {
    return {
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 200)
        }
      },
      isShowTestMenu: false, // 本地开发
      dialogVisible: false, // 添加化学品弹窗
      returnShowPic: '', // 获取照片路径前缀
      // 企业信息
      jbxxForm: {}, // 表单数据
      yyzzImg: {
        name: '营业执照',
        img: require('../../assets/img/yyzz2.png')
      },
      qyxxImgList: [], // 企业预览
      dwxzList: [], // 单位性质列表
      dwlxList: [], // 单位类型
      djdwList: [], // 货币列表
      gsgajg: [], // 行政区划
      YyqxDate: [], // 企业营业期限
      // 显示字段开关
      labelFlag: {
        dwmc: true, // 单位名称
        shtyxydm: true, // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: true, // 单位类型
        dwzs: true, // 单位住所
        frmc: true, // 法人/经营者名称
        zczb: true, // 注册资本
        clrq: true, // 成立日期
        jyfw: true, // 经营范围
        dwzj: true, // 单位座机
        sjjyd: true, // 实际经营地
        cyrysl: true, // 从业人员数量
        YyqxDate: true, // 营业执照路径
        gsgajg: true
      },
      // 动态属性名
      dwxzWorld: '营业执照',
      dwmcName: '单位名称:',
      shtyxydmName: '统一社会信用代码:',
      dwlxName: '单位类型:',
      dwzsName: '单位住所:', //
      frmcName: '法人/经营者:', //
      zczbName: '注册资本:', //
      clrqName: '成立日期:', //
      jyfwName: '经营范围:', //
      dwzjName: '单位座机:', // 单位座机
      sjjydName: '实际经营地:', //
      cyryslName: '从业人员数量:', //
      YyqxDateName: '营业期限:', //
      gsgajgName: '行政区划:',
      frYxqxDate: [], // 法人营业期限
      farenImgList: [], // 法人证件列表
      sfzImgList: [
        {
          name: '证件人像面',
          path: require('../../assets/img/zjrlx.png')
        },
        {
          name: '证件国徽面',
          path: require('../../assets/img/zjghx.png')
        }
      ],
      sexList: [
        {
          label: '男',
          value: '0'
        },
        {
          label: '女',
          value: '1'
        },
        {
          label: '未知',
          value: '2'
        }
      ],
      puptype: '',
      content: '',
      mzList: [], // 民族
      hxpTotal: 0, // 化学品列表总数
      dwFjlxZl: [], // 证件类型数组
      imagezjlx: 0, // 证件类型
      type: true,
      headerlist: [], // 证件详情表头
      imagetableData: [], // 证件详情数据
      dialogFormVisible1: false,
      dialogFormVisible: false, // 对话框的显示隐藏
      title: '', // 弹框标题
      imgListArray: [], // 证件列表
      rwSpjgDto: {}, // 入网审批
      bgSpjgDtos: [], // 变更审批
      pagesize: 10, // 分页大小
      currentPage: 1, // 分页当前页
      tableData: [], // 化学品表
      frxxForm: {} // 法人form
    }
  },
  computed: {},
  watch: {
    jbxxForm(newValue, oldValue) {
      this.panduan(newValue.dwxzLabel)
      // 营业执照
      this.yyzzImg.img = this.returnShowPic + newValue.yyzzUrl
      this.qyxxImgList.push(this.yyzzImg.img)
      // 有效期限
      this.YyqxDate = [newValue.yyqxKs, newValue.yyqxJs]
      // 行政区划
      this.gsgajg = [newValue.province, newValue.city, newValue.county]
    },
    frxxForm(newValue, oldValue) {
      this.frxxForm.jg = newValue.jg
      this.frYxqxDate = [newValue.yxqxKs, newValue.yxqxJs]
      if (newValue.zjlx == '1') {
        // 身份证
        this.sfzImgList = [
          {
            name: '证件人像面',
            path: this.returnShowPic + newValue.zjzpZm
          },
          {
            name: '证件国徽面',
            path: this.returnShowPic + newValue.zjzpFm
          }
        ]
        this.farenImgList.push(
          this.returnShowPic + newValue.zjzpZm,
          this.returnShowPic + newValue.zjzpFm
        )
      } else if (newValue.zjlx == '4') {
        // 其他
        this.sfzImgList = [
          {
            name: newValue.qtzjLabel,
            path: this.returnShowPic + newValue.zjzpZm
          }
        ]
        this.farenImgList.push(this.returnShowPic + newValue.zjzpZm)
      }
    },
    // 获取证件类型列表
    dwFjlxZl(newValue, oldValue) {
      this.imgListArray = [
        {
          zjlx: 23,
          name: '其他证件',
          imageurl: require('@/assets/img/step41.png'),
          flag: false
        }
      ]
      newValue.forEach((element) => {
        switch (element) {
          case '6':
            this.imgListArray.push({
              zjlx: 6,
              name: '安全生产许可证',
              imageurl: require('@/assets/img/step41.png')
            })
            break
          case '2':
            this.imgListArray.push({
              zjlx: 2,
              name: '非药品类易制毒化学品生产许可证',
              imageurl: require('@/assets/img/step42.png')
            })
            break
          case '13':
            this.imgListArray.push({
              zjlx: 13,
              name: '非药品类易制毒化学品生产备案证明',
              imageurl: require('@/assets/img/step43.png')
            })
            break
          case '16':
            this.imgListArray.push({
              zjlx: 16,
              name: '危险化学品经营许可证',
              imageurl: require('@/assets/img/step47.png'),
              flag: false
            })
            break
          case '22':
            this.imgListArray.push({
              zjlx: 22,
              name: '合法使用需要证明',
              imageurl: require('@/assets/img/step44.png'),
              flag: false
            })
            break
          case '3':
            this.imgListArray.push({
              zjlx: 3,
              name: '非药品类易制毒化学品经营许可证',
              imageurl: require('@/assets/img/step46.png')
            })
            break
          case '17':
            this.imgListArray.push({
              zjlx: 17,
              name: '非药品类易制毒化学品经营备案证明',
              imageurl: require('@/assets/img/step48.png'),
              flag: true
            })
            break
          case '12':
            this.imgListArray.push({
              zjlx: 12,
              name: '道路运输经营许可证',
              imageurl: require('@/assets/img/step49.png')
            })
            break
          case '24':
            this.imgListArray.push({
              zjlx: 24,
              name: '危险货物道路运输许可证',
              imageurl: require('@/assets/img/step410.png')
            })
            break
        }
      })
    }
  },
  created() {},
  mounted() {
    this.isShowTestMenu = process.env.VUE_APP_SHOW_TEST_MENU === 'true'
    this.loadDataSource()
  },
  methods: {
    baosunEditData(data) {
      saveHxpxx(data, this.$store.state.RWLCType)
        .then((e) => {
          this.$message.success('修改成功')
          this.dialogVisible = false // 关闭编辑窗口
        })
    },
    saveDoc() {
      const link = document.createElement('a')
      link.href = process.env.VUE_APP_PUBLIC_PORT + '/api.docx'
      link.download = '第三方接口文档'
      link.click()
    },
    // 打开 添加化学品列表行数据弹窗
    addMes(row) {
      this.puptype = 'edit'
      this.content = row
      this.dialogVisible = true
    },
    handleView(index, row) {
      this.dialogFormVisible = true
      this.type = true
      if(!isEmpty(this.nowDwId)){
        getFjxxByFjsjIdAndDwId(row.id,this.nowDwId).then((e) => {
          this.$refs.dialog1.csh(e.data.data)
        })
      }else{
        getFjxxByFjsjId(row.id).then((e) => {
          this.$refs.dialog1.csh(e.data.data)
        })
      }

    },
    // 加入往来单位
    joinwldw() {
      wldwAdd(this.qyarray).then((e) => {
        this.$message({
          message: '成功加入往来单位',
          type: 'success'
        })
        this.qyarray.isWldw = true
      })
    },
    loadDataSource() {
      // 单位相关
      this.returnShowPic = returnShowPic()
      /* 单位性质 */
      getkv('yzd_dwxz').then((e) => {
        this.dwxzList = e.data.data
      })
      /* 单位类型 */
      getkv('yzd_dwlx').then((e) => {
        this.dwlxList = e.data.data
      })
      /* 单价单位 */
      getkv('yzd_xkzdjdw').then((e) => {
        this.djdwList = e.data.data
      })
      // 法人相关
      getkv('yzd_mz').then((e) => {
        this.mzList = e.data.data
      })

      if (this.dwhcpd) {
        if(!isEmpty(this.nowDwId)){ //根据单位主键查询单位信息
          getQyxxById(this.nowDwId).then((e) => {
            const data = e.data.data
            this.jbxxForm = data.qyxxDto
            this.frxxForm = data.dwCyryDto
            if (data.dwFjlxZl) {
              this.dwFjlxZl = data.dwFjlxZl.split(',')
            }
            this.rwSpjgDto = data.rwSpjgDto
            this.bgSpjgDtos = data.bgSpjgDtos
          })
        }else{
          getQyxx().then((e) => {
            const data = e.data.data
            this.jbxxForm = data.qyxxDto
            this.frxxForm = data.dwCyryDto
            if (data.dwFjlxZl) {
              this.dwFjlxZl = data.dwFjlxZl.split(',')
            }
            this.rwSpjgDto = data.rwSpjgDto
            this.bgSpjgDtos = data.bgSpjgDtos
          })
        }
      } else {
        this.jbxxForm = this.qyarray
      }
      // 化学品信息
      this.getHxpxxMet()
    },
    // 判断显示字段
    panduan(value) {
      switch (value) {
        case '企业':
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '分公司':
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业执照路径
            gsgajg: true
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '社会团体':
          this.dwxzWorld = '社会团体法人/经营者登记证书'
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            sjjyd: true, // 实际经营地
            zczb: true, // 注册资本
            gsgajg: true,
            YyqxDate: true, // 营业执照路径
            clrq: true // 成立日期
          }
          this.dwmcName = '名称:'
          this.jyfwName = '业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.sjjydName = '活动地域:' //
          this.zczbName = '注册资本:' //
          this.gsgajgName = '业务主管单位:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:'
          break
        case '事业单位':
          this.dwxzWorld = '事业单位法人/经营者证书'
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            zczb: true, // 注册资本
            gsgajg: true,
            YyqxDate: true,
            clrq: true // 成立日期
          }
          this.dwmcName = '名称:'
          this.jyfwName = '宗旨和业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.zczbName = '开办资金:' //
          this.gsgajgName = '登记管理机关:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          break
        case '党政机关':
          this.dwxzWorld = '行政执法主体资格证'
          this.labelFlag = {
            dwmc: true, // 单位名称
            dwzs: true, // 单位住所
            YyqxDate: true, // 营业执照路径
            shtyxydm: true, // 社会统一信用代码
            gsgajg: true
          }
          this.dwmcName = '单位名称:'
          this.dwzsName = '办公地址:' //
          this.YyqxDateName = '有效期:' //
          this.shtyxydmName = '证件编号:'
          this.gsgajgName = '行政区划:'
          break
        case '其他':
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: false, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true,
            zhxs: true
          }
          this.dwmcName = '字号名称:'
          this.shtyxydmName = '注册号:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '有效期限:' //
          this.gsgajgName = '行政区划:'
          break
        default:
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            shtyxydm: true, // 社会统一信用代码
            dwmc: true, // 单位名称
            dwzs: true, // 单位住所
            jyfw: true, // 经营范围
            YyqxDate: true, // 营业执照路径
            clrq: true, // 成立日期
            gsgajg: true
          }
          this.shtyxydmName = '编号:'
          this.dwmcName = '单位名称:'
          this.dwzsName = '单位地址:' //
          this.jyfwName = '许可范围:' //
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          this.gsgajgName = '行政区划:'
          break
      }
    },
    // 获取化学品信息
    getHxpxxMet() {
      if(!isEmpty(this.nowDwId)) { //根据单位主键查询单位信息
        getHxpxxByDwid({ page: this.currentPage, size: this.pagesize, param: {}},this.nowDwId).then(
            (e) => {
              var data = e.data.data
              this.hxpTotal = data.total
              this.tableData = data.rows
            }
        )
      }else{
        getHxpxx({ page: this.currentPage, size: this.pagesize, param: {}}).then(
            (e) => {
              var data = e.data.data
              this.hxpTotal = data.total
              this.tableData = data.rows
            }
        )
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pagesize = val
      this.getHxpxxMet()
    },
    // 控制页面的切换
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getHxpxxMet()
    },
    // 根据附件类型获取字段名
    getFjTableMess(zjlx) {
      this.imagetableData = []
      if(!isEmpty(this.nowDwId)){
        getFjsjxxByZjlxAndDwid(zjlx,this.nowDwId).then((e) => {
          this.imagetableData = e.data.data
        })
      }else{
        getFjsjxxByZjlx(zjlx).then((e) => {
          this.imagetableData = e.data.data
        })
      }
      switch (zjlx) {
        case 2: // 非药品类易制毒化学品生产许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'pzcl', label: '生产品种' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'fzjg', label: '发证机关' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 3: // 非药品类易制毒化学品经营许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'pzcl', label: '经营品种' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 13: // 非药品类易制毒化学品生产备案证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'pzlb', label: '生产品种' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 17: // 非药品类易制毒化学品经营备案证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'pzcl', label: '经营品种' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 6: // 安全生产许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'jyfw', label: '许可范围' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 22: // 合法使用需要证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'hxpMcs', label: '化学品名称' },
            { prop: 'sjl', label: '涉及量' },
            { prop: 'fzrq', label: '签订日期' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 16: // 危险化学品经营许可
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '单位法定代表人' },
            { prop: 'jyfw', label: '许可范围' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 12: // 道路运输经营许可
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '业户名称' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 23: // 其他证件
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zsmc', label: '证件名称' },
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        case 24: // 危险货物道路运输许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '业户名称' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'fzrq', label: '发证日期' },
            { prop: 'statusLabel', label: '状态' },
            { prop: '', label: '操作' }
          )
          break
        default:
          break
      }
    },
    // 点击证件照片
    imageClick(item) {
      this.title = item.name
      this.imagezjlx = item.zjlx
      this.dialogFormVisible1 = true
      this.getFjTableMess(item.zjlx)
    },
    closeDialog() {
      // 关闭对话框
      this.dialogFormVisible = false
    }
  }
}
</script>
<style scoped lang='less'>
.qyjbxxBody {
  margin: auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  width: 95%;
  max-width: 1200px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 50px;
  .certificate_status{
    width: 90%;
    max-width: 950px;
    font-size: 14px;
    margin: 20px 0;
    .el-col{
      padding: 0;
      span{
        color: #8cdd81;
      }
      &:nth-child(2){
        text-align: center;
      }
      &:nth-child(3){
        text-align: right;
      }
    }
  }
  ._jbxxInfo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    max-width: 950px;
    /deep/.el-form-item__label {
      color: #333333 !important;
    }
  }
  .uploadzhengjian {
    width: 85%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-left: 0 !important;
    li {
      width: 26%;
      list-style: none;
      text-align: center;
      img {
        width: 202px;
        height: 138px;
      }
      p {
        text-align: center;
        margin: 10px 0 20px;
        span {
          margin-right: 5px;
        }
      }
    }
  }
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._title2 {
    border-top: 10px solid #eef1f9;
    padding-top: 40px;
  }
  .sfzDiv {
    height: 180px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 38px;
    margin-top: 40px;
    .sfzDivItem {
      &:nth-child(2) {
        margin-left: 30px;
      }
    }
  }
  ._jbxxTitle {
    margin: 40px 0 30px 0;
    width: 130px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
  }
  ._jbxxBd {
    margin-bottom: 40px;
    ._jbxxForm {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 45%;
        /deep/.el-form-item__content {
          display: flex !important;
        }
      }
    }
  }
  ._qtxxBd {
    margin: 30px 0px;
    ._qtxxForm {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .jydItem {
        /deep/.el-input {
          width: 830px;
        }
      }
      .el-input {
        width: 297px;
      }
      .el-textarea {
        width: 830px;
      }
      /deep/.el-input--suffix {
        width: 830px;
      }
    }
  }
}
/deep/.spResult {
  width: 90%;
  max-width: 950px;
  display: flex;
  // justify-content: space-between;
  margin: auto;
  // padding-bottom: 100px;
  .spjg {
    display: flex;
    align-items: center;
  }
}
.tableBody {
  width: 90%;
  max-width: 950px;
  margin-bottom: 54px;
  .el-pagination {
    border: solid 1px #ebeef5;
  }
  /deep/.el-table {
    td,
    th {
      text-align: center;
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-timeline-item__icon {
  font-size: 16px !important;
  color: #fff;
  background-color: #ef9a12;
  border-radius: 50%;
}

/deep/.el-icon-success {
  color: #6acd18;
  background-color: #fff;
}
</style>
